import {
    get,
    post,
    execute
} from "../axios";


/**
 * 获取商品空间导航信息
 * @param {goodsSpaceId}
 * @return {Promise} 
 */
export const GetGoodsSpaceNav = data => execute('eshopapi/v1/Home/GetGoodsSpaceNavigationInfo', data)

/**
 * 第一级：版面位 二：广告位 三：主题 四：主题内容
 * 根据广告位获取所有主题（可以通过主题内容类型筛选）
 * @param {adPositionId}
 * @return {Promise} 
 */
export const GetAdPositionId = data => execute('EShopApi/V1/Home/GetHomeAdListByPositionId', data)

/**
 * 根据广告位获取所有主题的主题内容（可以通过主题内容类型筛选）
 * @param {adPositionId}
 * @return {Promise} 
 */
export const GetAdPosAndType = data => execute('EShopApi/V1/Home/GetHomeAdListByPositionIdAndContentType', data)

/**
 * 根据广告主题获取广告内容
 * @param {adThemeId}
 * @return {Promise} 
 */
export const GetAdThemeId = data => execute('EShopApi/V1/Home/GetHomeAdListByThemeId', data)

/**
 * 根据信息定义获取信息分类及内容列表
 * @param {data}
 * @return {Promise} 
 */
export const GetBotInfo = data => execute('EShopApi/V1/Home/GetInfoCategoryListByDefineId', data)

/**
 * 获取信息内容详细
 * @param {id}
 * @return {Promise} 
 */
export const GetInfoDetail = data => execute('eshopapi/v1/Home/GetInfoDetail', data)

/**
 * 获取头部地址列表
 */
export const GetHeadRegionPro = data => execute('eshopapi/v1/Home/GetRegionProvince', data)


// 获取热销套系（整装拎包的数据源）
export const GetHotWholeList = data => execute('eshopapi/v1/GoodsWholeThemeSearch/GetRandomGoodsWholeThemeList', data)
// 获取商品标识里面的数据
export const GetTagGoodsList = data => execute('eshopapi/v1/GoodsSearchTag/GetRandomGoodsWholeThemeList', data)
// 通过标识no获取name
export const GetNameBySerNo = data => execute('eshopapi/v1/GoodsSearchTag/GetNameBySerNo', data)

// 获取品牌列表
export const GetBrandList = data => execute('eshopapi/v1/GoodsBrandList/GetSearchPageList', data)
// 获取品牌分类基本信息
export const GetBrandBasicInfo = data => execute('eshopapi/v1/GoodsSearchBrand/GetSearchBasicInfo', data)
// 获取品牌分类商品列表
export const GetBrandGoodsList = data => execute('eshopapi/v1/GoodsSearchBrand/GetMixSearchPageList', data)

// 获取基础信息
export const GetGoodsWholeSearchBasicInfo = data => execute('eshopapi/v1/GoodsWholeThemeSearch/GetSearchBasicInfo', data)
// 获取整装拎包列表
export const GetGoodsWholeSearchPageList = data => execute('eshopapi/v1/GoodsWholeThemeSearch/GetMixSearchPageList', data)
// 获取整装主题详情
export const GetGoodsDetailThemeDetailByNo = data => execute('eshopapi/v1/GoodsWholeDetail/GetThemeDetailByNo', data)
// 获取整装主题的选择搭配商品
export const GetGoodsWholeThemeDetailByNo = data => execute('eshopapi/v1/GoodsWholeCollocation/GetThemeDetailByNo', data)
// 获取整装主题的选择搭配商品 新版=》获取标配商品
export const GetSimpleThemeDetailByNo = data => execute('eshopapi/v1/GoodsWholeCollocation/GetSimpleThemeDetailByNo', data)

// 获取电器分类和属性
export const GetElectricBasicInfo = data => execute('eshopapi/v1/GoodsSearchElectricProp/GetSearchBasicInfo', data)
// 获取电器商品列表
export const GetElectricPageList = data => execute('eshopapi/v1/GoodsSearchElectricProp/GetMixSearchPageList', data)

// 获取风格列表
export const GetAllStyleInfo = data => execute('eshopapi/v1/GoodsSearchStyle/GetAllStyleInfo', data)
// 获取分类基本信息
export const GetStyleBasicInfo = data => execute('eshopapi/v1/GoodsSearchStyle/GetSearchBasicInfo', data)
// 获取（搜索）商品信息
export const GetStyleGoodsList = data => execute('eshopapi/v1/GoodsSearchStyle/GetMixSearchPageList', data)